module.exports = __webpack_public_path__ + "img/dpb-vault-active.9c65410e.svg";